import { render, staticRenderFns } from "./SchulgemeinschaftIcon.vue?vue&type=template&id=9fa58bb8"
import script from "./SchulgemeinschaftIcon.vue?vue&type=script&lang=js"
export * from "./SchulgemeinschaftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports